export const ROOT_URL = '/'
export const TERMS_URL = '/terms_and_conditions'
export const IMPRESSUM_URL = '/impressum'
export const BUSINESS_TERMS_URL = '/pro-terms-of-use'
export const REGISTER_SELECT_TYPE = '/member/register/select_type'
export const SIGNUP_HELP_ENTRIES_URL = '/help/103'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
